import { useEffect, useState } from "react";

import { useDocument } from "../../../../hooks/query";
import { useProject } from "../../../../hooks";
import { API_ENDPOINTS } from "../../../../constants";
import { useProject as useProjectQuery } from "../../../../hooks/query";

export default function useContractSigning() {
    const { project } = useProject();
    const { useListById } = useProjectQuery();
    const listProjectByIdSvc = useListById();
    const { useList, useUpdateStatus, useTriggerContractSigning } = useDocument();
    const listDocListSvc = useList();
    const updateStatusSvc = useUpdateStatus();
    const triggerSigningSvc = useTriggerContractSigning();

    const [contractDocument, setContractDocument] = useState<any | null>(null);

    const getDocumentStatus = async () => {
        try {
            if (!project?.id) {
                return;
            }
            const response = await listDocListSvc.mutateAsync({ ProjectId: project.id });
            const contractDocument = response.find((document: any) => document.Name === "CONTRACT");
            if (contractDocument) {
                const imageUrl = API_ENDPOINTS.asset.getImageAsSrc(contractDocument.ThumbnailAssetId);
                contractDocument.thumbnailUrl = imageUrl;
            }
            setContractDocument(contractDocument);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getDocumentStatus().then();
    }, [project?.id]);

    const markAsSigned = async () => {
        if (!contractDocument?.Id) return;
        await updateStatusSvc.mutateAsync({ DocumentId: contractDocument.Id, Status: "SIGNED" });
        await getDocumentStatus();
    };

    const triggerSigning = async () => {
        try {
            if (!project?.id) return;

            // Get project details to get customer email
            const projectDetails = await listProjectByIdSvc.mutateAsync({ id: project.id });
            const customerEmail = projectDetails?.CustomerEmail || "";

            if (!customerEmail) {
                throw new Error("Customer email not found");
            }

            await triggerSigningSvc.mutateAsync({
                ProjectId: project.id,
                ToAddress: customerEmail,
            });

            // Refresh document status after sending email
            await getDocumentStatus();
        } catch (e) {
            console.error(e);
            throw e;
        }
    };

    return {
        contractDocument,
        markAsSigned,
        triggerSigning,
        isUpdatingStatus: updateStatusSvc.isPending,
        isTriggeringSigning: triggerSigningSvc.isPending,
        refreshContract: getDocumentStatus,
    };
}
